import React, { useEffect, useState } from "react";
import { checkAuthState } from "../../../../../../authentication/auth-utils/auth-utils";
import { useNavigate } from 'react-router-dom';
import ItemPhotosList from "./item-photos-list/item-photos-list";
import ItemPhotosAdd from "./item-photos-add/item-photos-add";
import ItemPhotosDelete from "./item-photos-delete/item-photos-delete";

const ItemPhotosContainer = (props) => {
    const item_id = props.item_id;
    const formData = props.formData;
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);

    return (
        <>
            <div style={{ padding: 20 }}>
                <ItemPhotosList item_id={item_id} formData={formData}/>
                <ItemPhotosAdd item_id={item_id}/>
                <ItemPhotosDelete item_id={item_id}/>
            </div>
        </>
    )
};

export default ItemPhotosContainer;